import { memo } from 'react';

import { Card, CardActionArea, Typography } from '@mui/material';

type Props = {
  action: {
    label: string;
    emoji: string;
    description: string;
  };
  disabled: boolean;
  onClick: () => void;
};

export const EnhanceActionCard = memo(
  ({ action: { emoji, label, description }, disabled, onClick }: Props) => (
    <Card
      variant="outlined"
      sx={{
        transition: 'all 0.15s',
        opacity: disabled ? 0.5 : 1,
        '&:hover': {
          borderColor: disabled ? undefined : 'primary.light',
        },
      }}
    >
      <CardActionArea
        onClick={onClick}
        disabled={disabled}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          px: 1.75,
          py: 1.5,
          height: '100%',
          justifyContent: 'flex-start',
        }}
      >
        <Typography
          sx={{ fontSize: 20, lineHeight: 1, mb: 1.5 }}
          aria-hidden="true"
        >
          {emoji}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            mb: 0.25,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          {description}
        </Typography>
      </CardActionArea>
    </Card>
  ),
);
